module.exports = __webpack_public_path__ + "application/templates/default/inner/processes/processes.template.html";